/**
 * The one error-and-busy pair every case panel carries: run a request, show
 * the service's own sentence when it refuses, and say whether it worked so
 * the panel knows to reload. Split out of the old `CasePanels.tsx` (Wave 15C).
 */

import { useCallback, useState } from 'react'

import { ApiError } from '../../lib/api'

export function useAction() {
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  const run = useCallback(async (fn: () => Promise<unknown>, fallback: string) => {
    setBusy(true)
    setError(null)
    try {
      await fn()
      return true
    } catch (err) {
      setError(err instanceof ApiError ? err.message : fallback)
      return false
    } finally {
      setBusy(false)
    }
  }, [])
  return { error, setError, busy, run }
}

/** Today in the reader's own day, `YYYY-MM-DD` — what `taskStatus` compares a
 *  due date against. */
export function todayIso(now = new Date()): string {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
}
